<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                memberForm: () => import('../forms/MemberForm'),
                fileForm: () => import('../forms/FileForm'),
                fields: [
                    { type: 'autocomplete', text: 'Member', value: 'memberId', rules: [v => !!v || 'Member is required'], isRequired: true, form: () => import('./MemberForm'), apiMethod: 'Members', claim: 'Members' },
                    { type: 'datetime', text: 'Started On', value: 'startedOn', rules: [] },
                    { type: 'datetime', text: 'Onsite Completed On', value: 'onsiteCompletedOn', rules: [] },
                    { type: 'datetime', text: 'Closed On', value: 'closedOn', rules: [] },
                    { type: 'file', text: 'Report File', value: 'reportFileId', rules: [], form: () => import('./FileForm'), apiMethod: 'Files' },
                ],
                apiMethod: 'InternalMemberAudits',
                formTitle: 'Internal Member Audit',
            }
        },
    };
</script>
